export const SORT_OPTIONS = {
    TIMESTAMP: "timestamp",
    LICENSE_PLATE: "licenseplate",
    CAR_BRAND: "carbrand",
    CAR_COLOR: "carcolor",
};

export const SORT_ORDER = {
    DESC: "desc",
    ASC: "asc",
}

export interface Options {
    pageSize: number;
    pageIndex: number;
    sort: typeof SORT_OPTIONS[keyof typeof SORT_OPTIONS];
    sortOrder: typeof SORT_ORDER[keyof typeof SORT_ORDER];
};

export interface Criteria {
    minDate: number;
    maxDate: number;
    licensePlate?: string;
}

export interface Entry {
    needsreview: boolean;
    isdataretransmission: boolean;
    timestamp: string;
    locationid: number;
    licenseplate: string;
    carbrand: string;
    carcolor: string;
    anprconfidencelevel: number;
    anprconfidencelevelchars: string;
    id: string;
    ismotorbike: boolean;
    imagesdeleted: boolean;
    imageLicensePlate: string;
    imageVehicle: string;
    isirrelevant: boolean;
};

export interface EntriesData {
    entries: Entry[];
    totalCount: number;
}

export interface EntriesPerMonth {
    countEntries: number[];
    months: string[];
}

export interface GetLicensePlateEntriesResponse {
    entries: EntriesData;
    entriesPerMonth: EntriesPerMonth;
}
export interface IrrelevantEntry {
    createdat: string;
    licenseplate: string;
    locationid: number;
    reason: string;
    createdbystaffid?: number | null;
    createdbystaffname: string;
}
